module.exports = __webpack_public_path__ + "static/media/achieve_v3.51a966a5.jpg";